module.exports = __webpack_public_path__ + "img/filler_2_mob.a5ac6f8c.svg";